/**
  商品路由配置
*/

// import stockQuery from '@/pages/stockQuery/index';
// import stockWater from '@/pages/stockWater/index';
// import stockMessage from '@/pages/StockMessage/index';
// import StockMessageDetail from '@/pages/StockMessageDetail';
// import StockAbnor from '@/pages/StockAbnor/index';
// import StockDiffManage from '@/pages/StockDiffManage';
// import StockRecord from '@/pages/StockRecord/index';
// import StockRecordDetails from '@/pages/StockRecordDetails/index';
import React from 'react';

export default [
  {
    path: '/goods/message/stockquery',
    // component: stockQuery,
    component: React.lazy(() => import(/* webpackChunkName: 'stockQuery' */ '@/pages/stockQuery/index')),
  },
  {
    path: '/goods/message/stockwater',
    // component: stockWater,
    component: React.lazy(() => import(/* webpackChunkName: 'stockWater' */ '@/pages/stockWater/index')),
  },
  {
    path: '/goods/message/stockmessage',
    // component: stockMessage,
    component: React.lazy(() => import(/* webpackChunkName: 'stockMessage' */ '@/pages/StockMessage/index')),
  },
  {
    path: '/goods/message/skucheckreview',
    // component: stockMessage,
    component: React.lazy(() => import(/* webpackChunkName: 'stockMessage' */ '@/pages/Skucheckreview/index')),
  },
  {
    path: '/goods/message/skucheckreviewDetail/:checkNo',
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/SkucheckreviewDetail/index')),
  },
  {
    path: '/goods/message/skuPalletSpec',
    // component: skuPalletSpec,
    component: React.lazy(() => import(/* webpackChunkName: 'SkuPalletSpec' */ '@/pages/SkuPalletSpec')),
  },
  {
    path: '/goods/message/skuDynamicSalesLevel',
    // component: skuDynamicSalesLevel,
    component: React.lazy(() => import(/* webpackChunkName: 'SkuDynamicSalesLevel' */ '@/pages/SkuDynamicSalesLevel')),
  },
  {
    path: '/goods/message/stockmessagedetail/:skuid',
    // component: StockMessageDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'StockMessageDetail' */ '@/pages/StockMessageDetail')),
  },
  {
    path: '/goods/message/stockAbnor',
    // component: StockAbnor,
    component: React.lazy(() => import(/* webpackChunkName: 'StockAbnor' */ '@/pages/StockAbnor/index')),
  },
  {
    path: '/goods/message/stockdiff',
    // component: StockDiffManage,
    component: React.lazy(() => import(/* webpackChunkName: 'StockDiffManage' */ '@/pages/StockDiffManage')),
  },
  {
    path: '/goods/message/abnormalLocationInventory',
    // component: AbnormalLocationInventory,
    component: React.lazy(() => import(/* webpackChunkName: 'StockDiffManage' */ '@/pages/AbnormalLocationInventory')),
  },
  {
    path: '/goods/message/stockRecord',
    // component: StockRecord,
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/StockRecord/index')),
  },
  {
    path: '/goods/message/stockRecordDetails/:adjustNo',
    // component: StockRecordDetails,
    component: React.lazy(
      () => import(/* webpackChunkName: 'StockRecordDetails' */ '@/pages/StockRecordDetails/index'),
    ),
  },
  {
    path: '/goods/message/mutilpleInventory',
    component: React.lazy(() => import('@/pages/MutilpleInventory')),
  },
  {
    path: '/goods/message/mutilpleInventoryFlow',
    component: React.lazy(() => import('@/pages/MutilpleInventoryFlow')),
  },
  {
    path: '/goods/packageInfo/invPackageInfoHistory',
    // component: invPackageInfoHistory,
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvPackageInfoHistory/index')),
  },
  {
    path: '/goods/packageInfo/packageInfoMaintain',
    // component: invPackageInfoHistory,
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/PackingMaterial/index')),
  },
  {
    path: '/goods/packageInfo/invPackageInfoManager',
    // component: invPackageInfoHistory,
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvPackageInfo/index')),
  },
  {
    path: '/goods/packageInfo/invPackageInfoHistoryException',
    component: React.lazy(
      () => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvPackageInfoHistoryException/index'),
    ),
  },
  {
    path: '/goods/packageInfo/invPackageInfoTakestock',
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvPackageInfoTakestock/index')),
  },
  {
    path: '/goods/packageInfo/invPackageInfoTakestockDetail/:tid',
    component: React.lazy(
      () => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvPackageInfoTakestockDetail/index'),
    ),
  },
  {
    path: '/goods/packageInfo/invPackageInfoTakestockAdd',
    component: React.lazy(
      () => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvPackageInfoTakestockAdd/index'),
    ),
  },
  {
    path: '/goods/packageInfo/invPackageInfoTakestockAdjust/:tid',
    component: React.lazy(
      () => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvPackageInfoTakestockAdjust/index'),
    ),
  },
  {
    path: '/goods/message/invDifferentJob',
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvDifferentJob/index')),
  },
  {
    path: '/goods/message/invDifferentJobDetail/:jobNo',
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/InvDifferentJobDetail/index')),
  },
  {
    path: '/goods/packageInfo/packageUseException',
    component: React.lazy(() => import(/* webpackChunkName: 'StockRecord' */ '@/pages/PackageUseException/index')),
  },
  {
    path: '/goods/packageInfo/packageUseExceptionDetail',
    component: React.lazy(
      () => import(/* webpackChunkName: 'StockRecord' */ '@/pages/PackageUseExceptionDetail/index'),
    ),
  },
];
